export const WALLET_GROUP_OPTIONS = [
  { value: "ethereum", label: "Ethereum (ERC20)" },
  { value: "bsc", label: "BNB Smart Chain (BEP20)" },
  { value: "bitcoin", label: "Bitcoin" },
  { value: "ripple", label: "Ripple (XRP)" },
  { value: "solana", label: "Solana" },
  { value: "tron", label: "Tron (TRC20)" },
  { value: "doge", label: "Dogecoin" },
  { value: "hyperliquid", label: "Hyperliquid" },
  { value: "rupiah", label: "Rupiah" },
];

const WALLET_GROUP_ADDRESS_VIEW = {
  ethereum: "EvmAddress",
  bsc: "EvmAddress",
  hyperliquid: "EvmAddress",
  bitcoin: "BitcoinAddress",
  ripple: "CipherbcAddress",
  tron: "CipherbcAddress",
  solana: "CipherbcAddress",
  doge: "CipherbcAddress",
};

const WALLET_GROUP_WD_HANDLERS = {
  ethereum: ["CipherbcCoin", "EVMToken", "EVMCoin"],
  bsc: ["CipherbcCoin", "EVMToken", "EVMCoin"],
  hyperliquid: ["EVMCoin", "EVMToken"],
  bitcoin: ["Bitcoin"],
  ripple: ["CipherbcCoin"],
  tron: ["CipherbcCoin"],
  solana: ["CipherbcCoin"],
  doge: ["CipherbcCoin"],
};

export function normalizeWalletGroups(walletGroup) {
  if (Array.isArray(walletGroup)) {
    return walletGroup.filter(Boolean);
  }
  if (walletGroup) {
    return [walletGroup];
  }
  return [];
}

export function getWalletGroupLabel(value) {
  const option = WALLET_GROUP_OPTIONS.find((item) => item.value === value);
  return option ? option.label : value;
}

export function getAddressViewForWalletGroup(group) {
  return WALLET_GROUP_ADDRESS_VIEW[group] || null;
}

export function getWdHandlerForWalletGroup(group, wdConfig) {
  const handlers = WALLET_GROUP_WD_HANDLERS[group] || [];
  if (!wdConfig || !wdConfig.length) {
    return handlers[0] || null;
  }
  return handlers.find((handler) => wdConfig.includes(handler)) || null;
}

export function getCipherbcSlugForWalletGroup(group) {
  const mapping = {
    solana: "sol",
    tron: "trx",
    ripple: "xrp",
    doge: "doge",
  };
  return mapping[group] || null;
}

export function resolveAddressView(ccurrencyObj, selectedNetwork) {
  if (selectedNetwork) {
    return getAddressViewForWalletGroup(selectedNetwork);
  }

  const config = ccurrencyObj?.ccurrency_config || {};
  return config.address_view || null;
}

export function resolveWdHandler(ccurrencyObj, selectedNetwork) {
  const wdConfig = ccurrencyObj?.wd_config || [];
  if (selectedNetwork) {
    return getWdHandlerForWalletGroup(selectedNetwork, wdConfig);
  }
  return null;
}
